module.exports = __webpack_public_path__ + "img/bilal.01d94cb7.png";